import axios from 'axios';

function walkNodes(currentNode, callback) {
  currentNode.childNodes.forEach(child => {
    if(child.nodeName === '#text') {
      callback(child);
    } else {
      if(child && child.classList && !child.classList.contains('notranslate')) {
        walkNodes(child, callback);
      }
    }
  });
}

class Plugin {
  constructor() {
    this.originalTexts = [];
    this.defaultLanguage = 'en';
    this.currentLanguage = 'en';
  }

  install(Vue) {
    Vue.prototype.$translator = this;
  }

  getLanguages() {
    const url = '/client-services/translation/languages';
    return axios.get(url).then(response => response.data);
  }

  translate(node, language) {
    if(this.currentLanguage === language) {
      return;
    }

    if(this.defaultLanguage === language) {
      this.revertNode(node);
    } else {
      this.translateNode(node, language);
    }
  }

  translateNode(node, language) {
    if(this.originalTexts.length === 0) {
      // Collect all the original texts.
      walkNodes(node, child => {
        this.originalTexts.push(child.nodeValue);
      });
    }

    let data = {
      texts: this.originalTexts,
      languageCode: language,
    };

    axios.post('/client-services/translation/translate', data).then(response => {
      let translatedTexts = response.data;

      // Update the texts values in the VDOM. Assumes same node order.
      walkNodes(node, child => {
        child.nodeValue = translatedTexts.shift();
      });

      this.currentLanguage = language;
    }).catch(console.log);
  }

  revertNode(node) {
    if(this.originalTexts.length > 0) {
      // Update the text values in the VDOM to their original values.
      walkNodes(node, child => {
        child.nodeValue = this.originalTexts.shift();
      });

      this.originalTexts = [];
      this.currentLanguage = this.defaultLanguage;
    }
  }
}

export default new Plugin();